import { MenuItem, useToast } from '@chakra-ui/react'
import * as crypto from 'crypto-js'
import { FC, useCallback, useMemo, useRef, useState } from 'react'
import CsvDownloader from 'react-csv-downloader'
import { GrDocumentCsv } from 'react-icons/gr'
import { useImmer } from 'use-immer'

import useTools from '@hook/shared/use-tools'

import { parseSalesKpiData } from '@helper/kpi/sales/parseSalesKpiData'
import kpi from '@service/kpi'

import { ILayoutToolsExportAction } from '@base/@types/components/Layout/Tools'

const ExcelSalesKpi: FC<ILayoutToolsExportAction> = ({
  headers,
  parser = parseSalesKpiData
}) => {
  const { isDisabled } = useTools()
  const toast = useToast()
  const [disabled, setDisabled] = useState(false)
  const [data, updateDataNew] = useImmer<any[]>([])
  const csvDownload = useRef(null)
  const columns = useMemo(() => {
    const data: any[] = []

    for (const header of headers!) {
      if (!header.columns) continue

      for (const column of header.columns) {
        if (column.show) {
          data.push({
            id: column.id,
            displayName: `${header.group} - ${column.name}`
          })
        }
      }
    }

    return data
  }, [headers])

  const rows = useMemo(() => {
    const parsedData = parser(data)

    const body = []

    for (const row of parsedData) {
      const item: any = {}

      for (const column of columns) {
        if (column.id === 'parametros-emax') {
          if (row[column.id].includes('.')) {
            item[column.id] = Number(row[column.id].replace('.', ''))
          } else {
            item[column.id] = Number(row[column.id])
          }
        } else {
          item[column.id] = row[column.id]
        }
      }

      body.push(item)
    }

    return body
  }, [columns, data, parser])

  const dataFetch = useCallback(async () => {
    try {
      let newParams = {}
      if (localStorage.getItem('kpiSalesParamsRequest')) {
        newParams = JSON.parse(
          crypto.AES.decrypt(
            localStorage.getItem('kpiSalesParamsRequest'),
            'CHAVE'
          ).toString(crypto.enc.Utf8) || ''
        )
      }

      kpi
        .getSaleIndicatorsData(newParams, 1)
        .then(({ data: { data } }) => {
          updateDataNew(data)
          setDisabled(true)
          csvDownload.current.handleClick()
          // downloadCsv(rows, columns, 'OTB - Acompanhamento')
        })
        .catch(() => {
          setDisabled(false)
        })
    } catch (error: any) {
      const { data } = error.response
      const message =
        data.response?.status === 400
          ? data.response?.data?.data[0].message
          : 'Ocorreu um problema interno. Tente novamente mais tarde'
      toast({
        title: 'Atenção.',
        description: message,
        status: 'warning',
        duration: 3000,
        isClosable: true
      })
    }
  }, [toast, updateDataNew])
  return (
    <>
      {disabled ? (
        <>
          <MenuItem
            p="2px 12px"
            fontSize="sm"
            bgColor="white"
            _hover={{ bg: 'gray.400' }}
            isDisabled={isDisabled}
            onClick={dataFetch}
            icon={<GrDocumentCsv />}
          >
            Exportar para Tabela
          </MenuItem>
          <CsvDownloader
            filename={'Kpi-Vendas'}
            columns={columns}
            datas={rows}
            ref={csvDownload}
            separator=";"
            wrapColumnChar='"'
            bom={true}
          ></CsvDownloader>
        </>
      ) : (
        <MenuItem
          p="2px 12px"
          fontSize="sm"
          bgColor="white"
          _hover={{ bg: 'gray.400' }}
          onClick={dataFetch}
          icon={<GrDocumentCsv />}
        >
          Exportar para Tabela
        </MenuItem>
      )}
    </>
  )
}
export default ExcelSalesKpi
